let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cGfRS")).then(() => parcelRequire('9nK7X'));